<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead"><span class="bold">Contents</span></h2>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/chapter1#ch01">1</a>
<br/>GUILLAUME LADOUCETTE WIPED HIS DELICATE FINGERS ON HIS trouser leg…
</p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/chapter2#ch02">2</a>
<br/>HAIRLESS CUSTOMERS WERE NOT A PROBLEM GUILLAUME Ladoucette had foreseen…
</p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><a href="#/chapter3#ch03">3</a>
<br/>A BREEZE SNIFFED ROUND THE ADJUSTABLE SIGN AT THE ENTRANCE…
</p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><span href="#/chapter4#ch04" title="Link target outside of Sample">4</span>
<br/>AS HE SAT WAITING IN HIS CAR, GUILLAUME LADOUCETTE PULLED…
</p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><span href="#/chapter5#ch05" title="Link target outside of Sample">5</span>
<br/>IT WAS MONSIEUR MOREAU WHO FIRST SPOTTED THE STRANGER walking…
</p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span href="#/chapter6#ch06" title="Link target outside of Sample">6</span>
<br/>GUILLAUME LADOUCETTE LED HIS FIRST CUSTOMER TO THE CHAIR with…
</p></div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/chapter7#ch07" title="Link target outside of Sample">7</span>
<br/>THE ONE PERSON IN AMOUR-SUR-BELLE WHO WELCOMED THE FACT that…
</p></div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/chapter8#ch08" title="Link target outside of Sample">8</span>
<br/>THE INSTALLATION OF THE MUNICIPAL SHOWER TURNED OUT TO BE…
</p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/chapter9#ch09" title="Link target outside of Sample">9</span>
<br/>WHEN LISETTE ROBERT ANSWERED HER DOOR TO FIND GUILLAUME Ladoucette…
</p></div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/chapter10#ch10" title="Link target outside of Sample">10</span>
<br/>‘DID YOU OR DID YOU NOT SUGGEST GOING HALVIES-HALVES?’ ASKED…
</p></div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/chapter11#ch11" title="Link target outside of Sample">11</span>
<br/>YVES LÉVÈQUE STOOD IN HIS GARDEN CONTEMPLATING THE unspeakable state…
</p></div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/chapter12#ch12" title="Link target outside of Sample">12</span>
<br/>UNFORTUNATELY FOR LISETTE ROBERT IT WAS MADAME Ladoucette who first…
</p></div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/chapter13#ch13" title="Link target outside of Sample">13</span>
<br/>MUCH TO HIS DISMAY, GUILLAUME LADOUCETTE ARRIVED AT WORK early.
</p></div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/chapter14#ch14" title="Link target outside of Sample">14</span>
<br/>ÉMILIE FRAISSE WOKE UP IN HER FOUR-POSTER RENAISSANCE BED feeling…
</p></div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryNumber"><span href="#/chapter15#ch15" title="Link target outside of Sample">15</span>
<br/>HEART’S DESIRE WAS CLOSED THE FOLLOWING MORNING. Guillaume Ladoucette had…
</p></div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryNumber"><span href="#/chapter16#ch16" title="Link target outside of Sample">16</span>
<br/>WHEN GUILLAUME LADOUCETTE OPENED HIS EYES THE FOLLOWING Sunday his…
</p></div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryNumber"><span href="#/chapter17#ch17" title="Link target outside of Sample">17</span>
<br/>UNFORTUNATELY FOR THE RESIDENTS OF AMOUR-SUR-BELLE IT WAS Madame Ladoucette…
</p></div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryNumber"><span href="#/chapter18#ch18" title="Link target outside of Sample">18</span>
<br/>IT WAS WHEN GUILLAUME LADOUCETTE WALKED SLOWLY downstairs in his…
</p></div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryNumber"><span href="#/chapter19#ch19" title="Link target outside of Sample">19</span>
<br/>PIERRE ROUZEAU LOCKED HIS FRONT DOOR IN THE CERTITUDE THAT…
</p></div>
<div class="contentsEntry" id="ch_20">
<p class="contentsEntryNumber"><span href="#/chapter20#ch20" title="Link target outside of Sample">20</span>
<br/>MADAME LADOUCETTE WAS THE FIRST TO WAKE THE MORNING following…
</p></div>
<br/>
<div class="contentsEntry1" id="ack_01">
<p class="contentsEntryName"><span href="#/acknowledgments#ack01" title="Link target outside of Sample">Acknowledgements</span></p>
</div>
<div class="contentsEntry1" id="ata_01">
<p class="contentsEntryName"><span href="#/abouttheauthor#ata01" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry1" id="cre_01">
<p class="contentsEntryName"><span href="#/credits#cre01" title="Link target outside of Sample">Credits</span></p>
</div>
<div class="contentsEntry1" id="cop_01">
<p class="contentsEntryName"><span href="#/copyright#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry1" id="atp_01">
<p class="contentsEntryName"><span href="#/aboutthepublisher#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?48ce3a4e